module.exports = __webpack_public_path__ + "static/media/portada_1.3b92514a.jpg";